import { registerInit } from "./initRegistry";
// @ts-ignore
import LZString = require("lz-string");

export function initFavorites(): void {
    const favoritesContainer = document.querySelector(".js-favorites") as HTMLElement | null;
    if (!favoritesContainer) return;

    const printLink = document.querySelector(".js-print") as HTMLAnchorElement | HTMLButtonElement | null;
    if (printLink) {
        printLink.addEventListener("click", () => {
            window.print();
        });
    }

    const btn = document.querySelector(".js-share") as HTMLButtonElement | HTMLAnchorElement | null;
    if (!btn) return;

    btn.addEventListener("click", () => {
        try {
            const storedCart = localStorage.getItem("fav") || "{}";
            let favObj: Record<string, unknown>;

            try {
                favObj = JSON.parse(storedCart);
            } catch {
                favObj = {};
            }

            const ids = Object.keys(favObj || {});
            const payload = JSON.stringify({ ids });
            const compressed = LZString.compressToEncodedURIComponent(payload);
            const url = "https://gbi-etalon.ru/favorites?share=" + compressed;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).catch(err => {
                    console.error("Clipboard error:", err);
                    window.prompt("Скопируйте ссылку вручную:", url);
                });
            } else {
                window.prompt("Скопируйте ссылку вручную:", url);
            }
        } catch (err) {
            console.error("Share error:", err);
        }
    });

    const itemsContainer = document.querySelector(".items") as HTMLElement | null;
    const emptyContainer = document.querySelector(".container-empty") as HTMLElement | null;
    const diffWrapper = document.querySelector(".diff-wrapper") as HTMLElement | null;

    function hideEmptyShowItems(): void {
        if (emptyContainer) emptyContainer.classList.add("hidden");
        if (itemsContainer) itemsContainer.classList.remove("hidden");
    }

    function showEmptyHideItems(): void {
        console.log('here');

        if (itemsContainer) {
            console.log('here1');
            itemsContainer.innerHTML = "";
            itemsContainer.classList.add("hidden");
            (itemsContainer as HTMLElement).style.display = "flex";
        }
        if (emptyContainer) {
            console.log('here2');
            emptyContainer.classList.remove("hidden");
            (emptyContainer as HTMLElement).style.display = "block";
        }

        if (diffWrapper) {
            (diffWrapper as HTMLElement).style.display = "none";
        }
    }

    function renderSkeletonCards(count: number): void {
        if (!itemsContainer) return;
        itemsContainer.innerHTML = "";

        for (let i = 0; i < count; i++) {
            const skeletonCard = `
<div class="item skeleton">
  <div class="image"></div>
  <div class="bottom-content">
    <div class="description">
      <div class="name"></div>
      <div class="price"></div>
      <div class="old-price"></div>
    </div>
    <div class="footer">
      <button class="in-cart"></button>
      <button class="buy-one-click"></button>
    </div>
  </div>
</div>`;
            itemsContainer.insertAdjacentHTML("beforeend", skeletonCard);
        }
    }

    interface FavItem {
        [key: string]: string | undefined;
        "js-cart-main-image"?: string;
        "js-cart-title"?: string;
        "js-cart-price"?: string;
        "js-cart-old-price"?: string;

        "js-cart-href"?: string;
        "js-cart-sku"?: string;
        "js-cart-width"?: string;
        "js-cart-height"?: string;
        "js-cart-weight"?: string;
        "js-cart-length"?: string;
        "js-cart-minimum"?: string;
        "js-cart-unit-price"?: string;
    }

    function formatPrice(value?: string): string {
        const num = parseFloat(value || "0");
        if (isNaN(num)) return "";
        return num
            .toFixed(2)               // 5125.2 -> "5125.20"
            .replace(/\B(?=(\d{3})+(?!\d))/g, " "); // "5 125.20"
    }

    function renderFavItemsFromObj(favObj: Record<string, FavItem>): void {
        if (!itemsContainer) return;

        itemsContainer.innerHTML = "";
        const ids = Object.keys(favObj || {});

        if (ids.length === 0) {
            showEmptyHideItems();
            return;
        }

        hideEmptyShowItems();

        ids.forEach(id => {
            const item = favObj[id];
            if (!item) return;

            const formattedPrice = formatPrice(item["js-cart-price"]);
            const unit = item["js-cart-unit-price"] || "шт.";

            const card = `
<div class="item js-product-item" data-js-product-id="${id}">
    <input type="hidden" class="js-cart-title" value="${item["js-cart-title"] || ""}">
    <input type="hidden" class="js-cart-href" value="${item["js-cart-href"] || ""}">
    <input type="hidden" class="js-cart-sku" value="${item["js-cart-sku"] || ""}">
    <input type="hidden" class="js-cart-price" value="${item["js-cart-price"] || ""}">
    <input type="hidden" class="js-cart-width" value="${item["js-cart-width"] || ""}">
    <input type="hidden" class="js-cart-height" value="${item["js-cart-height"] || ""}">
    <input type="hidden" class="js-cart-weight" value="${item["js-cart-weight"] || ""}">
    <input type="hidden" class="js-cart-length" value="${item["js-cart-length"] || ""}">
    <input type="hidden" class="js-cart-minimum" value="${item["js-cart-minimum"] || ""}">
    <input type="hidden" class="js-cart-unit-price" value="${item["js-cart-unit-price"] || ""}">

  <div class="image">
    <a href="${item["js-cart-href"] || ""}">
        <img class="js-cart-main-image" src="${item["js-cart-main-image"] || ""}" alt="" />
    </a>
    <div class="labels">
        <div class="labels-top">
            <div class="label-left">
                <div class="label-new">Новинка</div>
                <div class="label-action">Акция</div>
            </div>
            <div class="label-right">
                <div class="label-favorite">
                    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.23242 1.48389C10.4562 0.261962 11.9792 -0.00332632 13.5693 0.336426C16.17 0.880738 17.464 3.46133 16.4561 6.06982H16.4551C16.0939 6.99506 15.5577 7.84565 14.874 8.57666L14.873 8.57764C13.0221 10.5342 11.0519 12.3958 9.16016 14.3003L9.15918 14.2993C8.95703 14.5035 8.74601 14.6468 8.50098 14.6392C8.32081 14.6334 8.1608 14.5471 8.01074 14.4224L7.86328 14.2866C6.04346 12.4594 4.21018 10.6451 2.36328 8.84424C1.27598 7.78946 0.536789 6.44276 0.238281 4.97705C0.21214 4.84867 0.200631 4.71941 0.200195 4.59326L0.199219 4.22705C0.198535 4.02901 0.224789 3.83145 0.277344 3.64014C0.323698 3.47139 0.369827 3.30283 0.416992 3.1333C0.867724 1.4254 2.20379 0.530357 3.63672 0.276855C5.06009 0.0250569 6.61546 0.398763 7.55078 1.26416C7.61976 1.32809 7.6898 1.39204 7.75879 1.45557C8.18622 1.84894 8.84547 1.87032 9.23242 1.48389Z" fill="#F7F7F7" stroke="#3A3FC6" stroke-width="0.4"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="label-hit">Хит</div>
    </div>
  </div>
  <div class="bottom-content">
    <div class="description top">
      <div class="name title">
            <a href="${item["js-cart-href"] || ""}">${item["js-cart-title"] || ""}</a>
        </div>
      <div class="price">${formattedPrice ? `${formattedPrice}₽/${unit}` : ""}</div>
      <div class="old-price">${item["js-cart-old-price"] || ""}</div>
    </div>
    <div class="footer">
      <button class="in-cart cart-v2">В корзину</button>
      <button class="buy-one-click js-buy-one-click-v2">Купить в 1 клик</button>
    </div>
  </div>
</div>`;
            itemsContainer.insertAdjacentHTML("beforeend", card);
        });
    }

    function renderFavItemsFromLocalStorage(): void {
        const storedCart = localStorage.getItem("fav");
        if (!storedCart) {
            showEmptyHideItems();
            return;
        }

        let favObj: Record<string, FavItem>;

        try {
            favObj = JSON.parse(storedCart) as Record<string, FavItem>;
        } catch {
            showEmptyHideItems();
            return;
        }

        // 🔑 если объект пустой — тоже заглушка
        if (!favObj || Object.keys(favObj).length === 0) {
            showEmptyHideItems();
            return;
        }

        renderFavItemsFromObj(favObj);
    }

    function clearAllFav(): void {
        localStorage.removeItem("fav");
        renderFavItemsFromLocalStorage();
    }

    document.addEventListener("click", e => {
        const target = (e.target as HTMLElement | null)?.closest(".js-delete-all");
        if (target) {
            e.preventDefault();
            clearAllFav();
            if (emptyContainer && diffWrapper) {
                diffWrapper.style.display = "none";
                emptyContainer.style.display = "block";
            }
            return;
        }

        // ✅ Новое: удаление по клику на label-favorite
        const favTarget = (e.target as HTMLElement | null)?.closest(".label-favorite");
        if (favTarget) {
            e.preventDefault();
            e.stopPropagation();

            const item = favTarget.closest(".js-product-item");
            if (!item) return;

            const productId = item.getAttribute("data-js-product-id");
            if (!productId) return;

            const storedFav = localStorage.getItem("fav") || "{}";
            let favObj: Record<string, FavItem>;

            try {
                favObj = JSON.parse(storedFav) as Record<string, FavItem>;
            } catch {
                favObj = {};
            }

            delete favObj[productId];

            const keys = Object.keys(favObj);

            console.log(keys);
            console.log(keys.length);

            if (keys.length === 0) {
                // ⚠️ полностью очищаем fav и показываем заглушку
                localStorage.removeItem("fav");
                showEmptyHideItems();
            } else {
                localStorage.setItem("fav", JSON.stringify(favObj));
                renderFavItemsFromObj(favObj);
            }
            return;
        }
    });

    (function init() {
        const params = new URLSearchParams(window.location.search);
        const share = params.get("share");

        if (share) {
            // режим по share: грузим данные с сервера
            if (!diffWrapper) return;

            renderSkeletonCards(4);

            fetch(`/index.php?route=ajax/ajax/getProducts&share=${encodeURIComponent(share)}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                },
            })
                .then(r => r.json())
                .then((data: Record<string, FavItem>) => {
                    const ids = Object.keys(data || {});
                    const totalCountEl = document.querySelector(".total-count") as HTMLElement | null;
                    if (totalCountEl) {
                        totalCountEl.textContent = String(ids.length);
                    }

                    if (ids.length === 0) {
                        if (diffWrapper && emptyContainer) {
                            diffWrapper.style.display = "none";
                            emptyContainer.style.display = "block";
                        }
                        if (itemsContainer) itemsContainer.innerHTML = "";
                        return;
                    }

                    diffWrapper.style.display = "block";
                    if (emptyContainer) {
                        emptyContainer.style.display = "none";
                    }

                    renderFavItemsFromObj(data);
                })
                .catch(err => {
                    console.error("getProducts error:", err);
                    // fallback на локальное состояние
                    renderFavInitFromLocal();
                });

            return;
        }

        // если share нет — старая логика через localStorage
        renderFavInitFromLocal();
    })();

    function renderFavInitFromLocal(): void {
        const storedCart = localStorage.getItem("fav");
        let count = 0;

        if (storedCart) {
            try {
                const diffObj = JSON.parse(storedCart) as Record<string, unknown>;
                count = Object.keys(diffObj || {}).length;
            } catch {
                count = 0;
            }
        }

        console.log(count);

        const totalCountEl = document.querySelector(".total-count") as HTMLElement | null;
        if (totalCountEl) {
            totalCountEl.textContent = String(count);
        }

        if (!diffWrapper) return;

        if (count === 0) {
            if (emptyContainer) {
                diffWrapper.style.display = "none";
                emptyContainer.style.display = "block";
            }
            return;
        }

        diffWrapper.style.display = "block";

        renderSkeletonCards(count || 4);
        setTimeout(renderFavItemsFromLocalStorage, 2000);
    }
}

registerInit(initFavorites);
